import { ClubCollections } from '@data';
import { Text } from '@ui';

import * as css from './ClubTable.css';

type ClubTableProps = {
    clubs: ClubCollections;
    selectedClubs: number[];
    onClubClick: (clubId: number) => void;
};

export function ClubTable({ clubs, selectedClubs, onClubClick }: ClubTableProps) {
    return (
        <div className={css.table}>
            {clubs
                .sort((a, b) => b.clubs.length - a.clubs.length)
                .filter((clubType) => clubType.clubs.length > 0)
                .map((clubType) => {
                    const sortedClubs = Object.values(clubType?.clubs || []).sort((a, b) => a.id - b.id);
                    if (sortedClubs.length > 10) {
                        const half = Math.ceil(sortedClubs.length / 2);
                        return (
                            <div key={clubType.typeName} className={css.clubType.double}>
                                <h4 className={css.clubTitle}>{clubType.typeName}</h4>
                                <div className={css.clubGrid}>
                                    <div className={css.clubs}>
                                        {Object.values(sortedClubs.slice(0, half)).map((club) => {
                                            const isSelected = selectedClubs.some(
                                                (selectedClubId) => selectedClubId === club.id,
                                            );

                                            return (
                                                <button
                                                    key={club.id}
                                                    className={css.club({
                                                        isSelected,
                                                    })}
                                                    onClick={() => onClubClick(club.id)}
                                                >
                                                    <Text variant="h3" as="p">
                                                        {club.longName}
                                                    </Text>
                                                    <div
                                                        className={css.short({
                                                            isSelected,
                                                        })}
                                                    >
                                                        <Text variant="h3" color="inherit" as="p">
                                                            {club.shortName}
                                                        </Text>
                                                    </div>
                                                </button>
                                            );
                                        })}
                                    </div>
                                    <div className={css.clubs}>
                                        {Object.values(sortedClubs.slice(half)).map((club) => {
                                            const isSelected = selectedClubs.some(
                                                (selectedClubId) => selectedClubId === club.id,
                                            );
                                            return (
                                                <button
                                                    key={club.id}
                                                    className={css.club({
                                                        isSelected,
                                                    })}
                                                    onClick={() => onClubClick(club.id)}
                                                >
                                                    <Text variant="h3" as="p">
                                                        {club.longName}
                                                    </Text>
                                                    <div
                                                        className={css.short({
                                                            isSelected,
                                                        })}
                                                    >
                                                        <Text variant="h3" color="inherit" as="p">
                                                            {club.shortName}
                                                        </Text>
                                                    </div>
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        );
                    }
                    return (
                        <div
                            key={clubType.typeName}
                            className={sortedClubs.length === 1 ? css.clubType.singleHalf : css.clubType.single}
                        >
                            <h4 className={css.clubTitle}>{clubType.typeName}</h4>
                            <div className={css.clubs}>
                                {Object.values(clubType?.clubs || [])
                                    .sort((a, b) => a.id - b.id)
                                    .map((club) => {
                                        const isSelected = selectedClubs.some(
                                            (selectedClubId) => selectedClubId === club.id,
                                        );

                                        return (
                                            <button
                                                key={club.id}
                                                className={css.club({
                                                    isSelected,
                                                })}
                                                onClick={() => onClubClick(club.id)}
                                            >
                                                <Text variant="h3" as="p">
                                                    {club.longName}
                                                </Text>
                                                <div
                                                    className={css.short({
                                                        isSelected,
                                                    })}
                                                >
                                                    <Text variant="h3" color="inherit" as="p">
                                                        {club.shortName}
                                                    </Text>
                                                </div>
                                            </button>
                                        );
                                    })}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
}
